//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'LinsesParametrs',
  props: {
    parametrsList: {
      type: Array,
      default: () => []
    },
    productionTime: {
      type: String,
      default: '',
    },
    linkSettings: {
      type: Object,
      default: () => ({})
    },
  },
  methods: {
    isStatusCheck(status) {
      return status === 'On';
    }
  },
}
